import { logLevels, LogLevels } from "./level.js";
import { get } from "../cookie/get.js";
import { set } from "../cookie/set.js";
import { remove } from "../cookie/remove.js";

/*                                     */
const debugCookie = "debug";
const patternCookie = "debugPattern";
const levelCookie = "debugLevel";

/**
 *
 *
 *
 */
export function writeCookie(namespace: string | RegExp, level?: LogLevels): void {
  set(debugCookie, "true");
  set(patternCookie, typeof namespace === "string" ? namespace : namespace.source);

  if (level && level !== "error") {
    set(levelCookie, level);
  }
}

/**
 *
 */
export function removeCookie(): void {
  [debugCookie, patternCookie, levelCookie].forEach((c) => remove(c));
}

/**
 *
 *
 */
export function readCookie(): [RegExp | undefined, LogLevels] {
  const pattern = get(patternCookie);
  const level = get(levelCookie);

  return [
    pattern ? new RegExp(pattern) : undefined,
    (level && logLevels.includes(level as LogLevels) ? level : "error") as LogLevels,
  ];
}
